module.exports = __webpack_public_path__ + "img/all_the_data.180ae7dd.svg";